import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { imageURl } from "../../libs/env";

const ActivateModel = ({ 
  isOpen,
  toggle,
   
  }) => {
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop="static"
      data-tc = "wait-modal"
    >
      <ModalBody className="p-5 py-4">
        <div class="row align-items-center">
            <div class="col-10">
                <h3 class="text-darkblue mb-2 text-start"><strong>Activate your account</strong></h3>
            </div>
            <div class="col-2 text-end">
                <button onClick={toggle} className="btn p-0 me-2 ">
                <img src={`${imageURl}/close.png`} width="17px" alt="Cross img" />
                </button>
            </div>
        </div>
        <div>
            <p class="lead text-darkblue my-3 text-start">
                *To generate a quiz, please activate your account.
            </p>
        </div>
      </ModalBody>
    </Modal>
  );
};

ActivateModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

ActivateModel.defaultProps = { isOpen: false };

export default ActivateModel;
